import React from 'react';
import { useTranslation } from 'react-i18next';

const SelectBox = ({ 
    label, 
    value, 
    onChange, 
    options = [], 
    placeholder, 
    name, 
    disabled, 
    error, 
    className,
    mb=true
}) => {
    const { i18n } = useTranslation();
    const isRTL = i18n.dir() === 'rtl';

    return (
        <div className={`relative ${className} ${mb ? 'mb-[20px]' : ''}`}>
            {label && <label className='text-[14px] text-gray-700 font-bold mb-[10px] block'>{label}</label>}
            <div className="relative">
                <select
                    name={name}
                    value={value}
                    onChange={onChange}
                    disabled={disabled}
                    className={`bg-white border-[1px] border-[#D9D9D9] rounded-[5px] h-[42px] w-full px-[15px] text-[14px] focus:outline-none focus:border-taction focus:ring-1 focus:ring-taction appearance-none ${disabled ? 'bg-gray-100 cursor-not-allowed opacity-50' : ''}`}
                >
                    {placeholder && <option value="" disabled>{placeholder}</option>}
                    {options.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
                <div className={`pointer-events-none absolute inset-y-0 ${isRTL ? 'left-0' : 'right-0'} flex items-center px-2 text-gray-700`}>
                     <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                </div>
            </div>
            {error && <p className='text-red-500 text-[12px] mt-[5px]'>{error}</p>}
        </div>
    );
};

export default SelectBox;